'use client';

import 'reflect-metadata';

/**
 * Loads client-side polyfills required by @repo/api DTOs.
 * reflect-metadata must be imported in a 'use client' module to be included
 * in the client bundle — importing it in Server Components has no effect.
 */
export function ClientPolyfills() {
  return null;
}
